import { render, staticRenderFns } from "./ProductLeaf.vue?vue&type=template&id=fcb381de&"
import script from "./ProductLeaf.vue?vue&type=script&lang=ts&"
export * from "./ProductLeaf.vue?vue&type=script&lang=ts&"
import style0 from "./ProductLeaf.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports